import { Money } from "@quint/components";
import Layout from "@quint/components/layout";
import { pools } from "@quint/features/conventional/pools";
import { formatBigNumber } from "@quint/services/web3";
import { useTotalConventionalStakedQuints, useTotalConventionalStakedQuintsTVL } from "@quint/services/web3/hooks";
import { Image } from "@quint/ui";
import { Accordion } from "@quint/ui/accordion";
import dynamic from "next/dynamic";
import HeaderPattern from "public/images/conventional/pattern.png";
import { Suspense } from "react";

const StakingCardMobile = dynamic(() =>
  import("@quint/features/conventional/staking-card-mobile").then((res) => res.StakingCardMobile)
);
const StakingDesktopView = dynamic(() =>
  import("@quint/features/conventional/staking-desktop-view").then((res) => res.StakingDesktopView)
);

const TotalStaked = () => {
  const query = useTotalConventionalStakedQuints();

  return (
    <Money value={formatBigNumber(query.data)} className="font-semibold text-primary" isLoading={query.isLoading} />
  );
};
const TotalTVL = () => {
  const query = useTotalConventionalStakedQuintsTVL();

  return (
    <Money
      value={formatBigNumber(query.data)}
      className="font-semibold text-primary"
      isLoading={query.isLoading}
      currency="$"
    />
  );
};

const ConventionalStaking = () => {
  return (
    <Layout>
      <div className="absolute inset-x-0 z-[-1] flex justify-end mix-blend-soft-light">
        <div className="flex min-w-[2000px] justify-end overflow-hidden">
          <Image quality={100} src={HeaderPattern} alt="conventional staking header pattern" loading="eager" />
        </div>
      </div>
      <div className="relative flex flex-col items-center gap-4 overflow-hidden px-6 pb-10 text-center md:flex-row md:justify-between md:px-16 md:text-left">
        <h2 className="font-satoshi text-[48px] font-bold md:text-[64px]">Conventional Staking Pools</h2>
        <div className="flex w-full justify-around md:w-auto md:justify-start md:gap-5">
          <div className="flex flex-col gap-2 md:flex-row md:items-center">
            <p className="text-sm">STAKED</p>
            <TotalStaked />
          </div>
          {/* divider */}
          <div className="hidden h-[24px] w-[1px] bg-[#E6E8EA] dark:bg-[#354856] md:block" />

          <div className="flex flex-col gap-2 md:flex-row md:items-center">
            <p className="text-sm">TVL</p>
            <TotalTVL />
          </div>
        </div>
      </div>
      <div className="flex grow items-center justify-center bg-white px-6 py-4 dark:bg-[#01111D] md:px-16">
        <>
          {/* mobile */}
          <Suspense fallback={<div>Loading...</div>}>
            <Accordion type="single" collapsible className="grid w-full gap-4 xl:hidden">
              {pools.map((pool) => (
                <StakingCardMobile key={pool.name} {...pool} />
              ))}
            </Accordion>
          </Suspense>
          {/* desktop */}
          <Suspense fallback={<div>Loading...</div>}>
            <StakingDesktopView data={pools} />
          </Suspense>
        </>
      </div>
    </Layout>
  );
};

export default ConventionalStaking;
